import axios from "axios";
import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { base_url } from "../../../../config";

const PhoneInput = ({
  setGetOtpClicked,
  phone,
  setPhone,
  setEmailClicked,
  fetchProfileData,
  setIsVisible,
  setAccessToken
}) => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false); // State to manage loading
  const [response, setResponse] = useState(null); // State to store API response
  const [error, setError] = useState(false);
  const handleInputChange = (event) => {
    let value = event.target.value;
    // Allow only numbers
    value = value.replace(/[^0-9]/g, '');
    // Remove leading "0" if phone starts with it
    if (value.startsWith("0")) {
      value = value.substring(1);
    }
    setPhone(value); // Update state with processed value
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return "mobile";
    }
    return "web"; // Default to web if not mobile/tablet
  };

  const isValidPhoneNumber = (phone) => {
    if (!/^\d{10}$/.test(phone)) return false; // Must be exactly 10 digits
    return !/^(.)\1{9}$/.test(phone); // Reject repeated digits like "1111111111"
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let processedPhone = phone;
    if (processedPhone.length === 11 && processedPhone.startsWith("0")) {
      processedPhone = processedPhone.substring(1);
    }

    if (!processedPhone || !isValidPhoneNumber(processedPhone)) {
      setError(true);
      toast.error(
        "Invalid phone number. Please enter a valid 10-digit number.",
        {
          position: "top-center",
        }
      );
      setLoading(false);
      return;
    }
    const body = {
      phone: processedPhone, // Use the processed value
      client_id: "CLIENT002",
      client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
      grant_type: "refresh_token",
      device_id: localStorage.getItem("deviceId"),
      device_type: getDeviceType(),
    };

    // Add user_type if it exists in query parameters
    const userType = searchParams.get("user_type");
    if (userType) {
      body.user_type = userType;
      console.log('PhoneInput - Added user_type to payload:', body);
    }

    try {
      const { data } = await axios.post(`${base_url}/users/login-otp`, body, {
        headers: { "Content-Type": "application/json" },
      });

      if (data?.access_token) {
        setAccessToken(data.access_token)
        setEmailClicked(true);
      } else {
        setGetOtpClicked(true);
      };

      setResponse(data);
    } catch (error) {
      setResponse(error.response?.data || { error: error.message });
      toast.error(error.response?.data || error.message , {
        position: "top-center",
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="no-margin w-form">
      <form
        onSubmit={handleSubmit}
        id="wf-form-signup"
        name="wf-form-signup"
        data-name="signup"
        method="get"
        data-ms-form="signup"
        className="signup-container"
        data-wf-page-id="67499980c22f84a4749844cf"
        data-wf-element-id="8a99125d-fbbe-eda5-7895-cece5afc1721"
      >
        <a href="#" className="login-logo w-inline-block" />

        <>
          <div className="phone-wrapper">
            <div className="countrycode">
              <div className="flag-code-wrapper">
                <div className="flagcode w-embed">
                  <>
                    {/*?xml version="1.0" encoding="utf-8"?*/}
                    <svg
                      version="1.1"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 122.88 85.48"
                      style={{ enableBackground: "new 0 0 122.88 85.48" }}
                      xmlSpace="preserve"
                      className="social-image"
                    >
                      <style
                        type="text/css"
                        dangerouslySetInnerHTML={{
                          __html:
                            "\n\t.st0{fill:#128807;}\n\t.st1{fill:#FF9933;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#000088;}\n",
                        }}
                      />
                      <g>
                        <path
                          className="st1"
                          d="M6.71,0h109.46c3.7,0.02,6.71,3.05,6.71,6.75v71.98c0,3.71-3.04,6.75-6.75,6.75l-109.42,0 C3.02,85.46,0,82.43,0,78.73V6.75C0,3.05,3.01,0.02,6.71,0L6.71,0z"
                        />
                        <polygon
                          className="st2"
                          points="0,28.49 122.88,28.49 122.88,56.99 0,56.99 0,28.49"
                        />
                        <path
                          className="st0"
                          d="M0,56.99h122.88v21.74c0,3.71-3.04,6.75-6.75,6.75l-109.42,0C3.02,85.46,0,82.43,0,78.73V56.99L0,56.99z"
                        />
                        <path
                          className="st3"
                          d="M72.84,42.74c0-6.3-5.1-11.4-11.4-11.4s-11.4,5.1-11.4,11.4c0,6.29,5.1,11.4,11.4,11.4 S72.84,49.04,72.84,42.74L72.84,42.74z"
                        />
                        <path
                          className="st2"
                          d="M71.41,42.74c0-5.51-4.46-9.97-9.97-9.97s-9.97,4.46-9.97,9.97c0,5.51,4.46,9.97,9.97,9.97 S71.41,48.25,71.41,42.74L71.41,42.74z"
                        />
                        <path
                          className="st3"
                          d="M63.43,42.74c0-1.1-0.89-2-1.99-2s-1.99,0.89-1.99,2c0,1.1,0.89,1.99,1.99,1.99S63.43,43.84,63.43,42.74 L63.43,42.74z"
                        />
                        <path
                          className="st3"
                          d="M71.82,44.11c0.04-0.27-0.16-0.52-0.43-0.56c-0.27-0.04-0.52,0.16-0.56,0.43s0.16,0.52,0.43,0.56 C71.54,44.57,71.79,44.38,71.82,44.11L71.82,44.11z"
                        />
                        <polygon
                          className="st3"
                          points="61.44,52.71 61.78,46.73 61.44,43.88 61.1,46.73 61.44,52.71"
                        />
                        <path d="M71.11,46.75c0.11-0.25-0.02-0.55-0.27-0.65c-0.25-0.11-0.55,0.02-0.65,0.27c-0.11,0.25,0.02,0.55,0.27,0.65 C70.72,47.12,71.01,47,71.11,46.75L71.11,46.75z" />
                        <polygon points="58.86,52.37 60.74,46.68 61.15,43.84 60.08,46.51 58.86,52.37" />
                        <path d="M69.75,49.12c0.17-0.22,0.13-0.53-0.09-0.7c-0.22-0.17-0.53-0.13-0.7,0.09c-0.17,0.22-0.13,0.53,0.09,0.7 C69.27,49.38,69.58,49.33,69.75,49.12L69.75,49.12z" />
                        <polygon points="56.45,51.38 59.74,46.37 60.87,43.73 59.15,46.02 56.45,51.38" />
                        <path d="M67.81,51.05c0.22-0.17,0.26-0.48,0.09-0.7c-0.17-0.22-0.48-0.26-0.7-0.09c-0.22,0.17-0.26,0.48-0.09,0.7 C67.28,51.17,67.6,51.22,67.81,51.05L67.81,51.05z" />
                        <polygon points="54.39,49.79 58.86,45.8 60.63,43.55 58.38,45.32 54.39,49.79" />
                        <path d="M65.45,52.42c0.25-0.11,0.38-0.4,0.27-0.65c-0.11-0.25-0.4-0.38-0.65-0.27c-0.25,0.1-0.38,0.4-0.27,0.65 C64.9,52.4,65.19,52.52,65.45,52.42L65.45,52.42z" />
                        <polygon points="52.8,47.73 58.16,45.03 60.45,43.31 57.81,44.44 52.8,47.73" />
                        <path d="M62.81,53.12c0.27-0.04,0.46-0.29,0.43-0.56c-0.04-0.27-0.29-0.46-0.56-0.43c-0.27,0.04-0.46,0.29-0.43,0.56 C62.28,52.97,62.53,53.16,62.81,53.12L62.81,53.12z" />
                        <polygon points="51.81,45.32 57.68,44.1 60.34,43.04 57.5,43.44 51.81,45.32" />
                        <path d="M60.07,53.12c0.27,0.04,0.52-0.16,0.56-0.43c0.04-0.27-0.16-0.52-0.43-0.56c-0.27-0.04-0.52,0.16-0.56,0.43 C59.61,52.84,59.8,53.09,60.07,53.12L60.07,53.12z" />
                        <polygon points="51.47,42.74 57.45,43.08 60.3,42.74 57.45,42.4 51.47,42.74" />
                        <path d="M57.43,52.42c0.25,0.11,0.55-0.02,0.65-0.27s-0.02-0.55-0.27-0.65c-0.25-0.11-0.55,0.02-0.65,0.27 C57.06,52.02,57.18,52.31,57.43,52.42L57.43,52.42z" />
                        <polygon points="51.81,40.16 57.5,42.04 60.34,42.45 57.68,41.38 51.81,40.16" />
                        <path d="M55.06,51.05c0.22,0.17,0.53,0.13,0.7-0.09c0.17-0.22,0.13-0.53-0.09-0.7c-0.22-0.17-0.53-0.13-0.7,0.09 C54.81,50.57,54.85,50.88,55.06,51.05L55.06,51.05z" />
                        <polygon points="52.8,37.75 57.81,41.04 60.45,42.17 58.16,40.45 52.8,37.75" />
                        <path d="M53.13,49.12c0.17,0.22,0.48,0.26,0.7,0.09c0.22-0.17,0.26-0.48,0.09-0.7c-0.17-0.22-0.48-0.26-0.7-0.09 C53.01,48.58,52.96,48.9,53.13,49.12L53.13,49.12z" />
                        <polygon points="54.39,35.69 58.38,40.16 60.63,41.94 58.86,39.68 54.39,35.69" />
                        <path d="M51.76,46.75c0.11,0.25,0.4,0.38,0.65,0.27c0.25-0.11,0.38-0.4,0.27-0.65c-0.11-0.25-0.4-0.38-0.65-0.27 C51.78,46.2,51.66,46.49,51.76,46.75L51.76,46.75z" />
                        <polygon points="56.45,34.1 59.15,39.46 60.87,41.75 59.74,39.12 56.45,34.1" />
                        <path d="M51.06,44.11c0.04,0.27,0.29,0.46,0.56,0.43c0.27-0.04,0.46-0.29,0.43-0.56c-0.04-0.27-0.29-0.46-0.56-0.43 C51.21,43.58,51.02,43.83,51.06,44.11L51.06,44.11z" />
                        <polygon points="58.86,33.11 60.08,38.98 61.15,41.64 60.74,38.8 58.86,33.11" />
                        <path d="M51.06,41.37c-0.04,0.27,0.16,0.52,0.43,0.56c0.27,0.04,0.52-0.16,0.56-0.43c0.04-0.27-0.16-0.52-0.43-0.56 C51.34,40.91,51.09,41.1,51.06,41.37L51.06,41.37z" />
                        <polygon points="61.44,32.77 61.1,38.75 61.44,41.6 61.78,38.75 61.44,32.77" />
                        <path d="M51.77,38.73c-0.11,0.25,0.02,0.55,0.27,0.65c0.25,0.1,0.55-0.02,0.65-0.27c0.11-0.25-0.02-0.55-0.27-0.65 C52.16,38.36,51.87,38.48,51.77,38.73L51.77,38.73z" />
                        <polygon points="64.02,33.11 62.14,38.8 61.73,41.64 62.8,38.98 64.02,33.11" />
                        <path d="M53.13,36.37c-0.17,0.22-0.13,0.53,0.09,0.7c0.22,0.17,0.53,0.13,0.7-0.09c0.17-0.22,0.13-0.53-0.09-0.7 C53.61,36.11,53.3,36.15,53.13,36.37L53.13,36.37z" />
                        <polygon points="66.43,34.1 63.14,39.12 62.01,41.75 63.73,39.46 66.43,34.1" />
                        <path d="M55.07,34.43c-0.22,0.17-0.26,0.48-0.09,0.7c0.17,0.22,0.48,0.26,0.7,0.09c0.22-0.17,0.26-0.48,0.09-0.7 S55.28,34.27,55.07,34.43L55.07,34.43z" />
                        <polygon points="68.49,35.69 64.02,39.68 62.25,41.94 64.5,40.16 68.49,35.69" />
                        <path d="M57.43,33.07c-0.25,0.11-0.37,0.4-0.27,0.65c0.11,0.25,0.4,0.38,0.65,0.27c0.25-0.11,0.38-0.4,0.27-0.65 C57.98,33.08,57.69,32.96,57.43,33.07L57.43,33.07z" />
                        <polygon points="70.08,37.75 64.72,40.45 62.43,42.17 65.07,41.04 70.08,37.75" />
                        <path d="M60.07,32.36c-0.27,0.04-0.46,0.29-0.43,0.56c0.04,0.27,0.29,0.46,0.56,0.43c0.27-0.04,0.47-0.29,0.43-0.56 C60.6,32.52,60.35,32.32,60.07,32.36L60.07,32.36z" />
                        <polygon points="71.07,40.16 65.2,41.38 62.54,42.45 65.38,42.04 71.07,40.16" />
                        <path d="M62.81,32.36c-0.27-0.04-0.52,0.16-0.56,0.43c-0.04,0.27,0.16,0.52,0.43,0.56c0.27,0.04,0.52-0.16,0.56-0.43 C63.27,32.65,63.08,32.39,62.81,32.36L62.81,32.36z" />
                        <polygon points="71.41,42.74 65.43,42.4 62.58,42.74 65.43,43.08 71.41,42.74" />
                        <path d="M65.45,33.07c-0.25-0.11-0.55,0.02-0.65,0.27c-0.11,0.25,0.02,0.55,0.27,0.65c0.25,0.1,0.55-0.02,0.65-0.27 C65.82,33.46,65.7,33.17,65.45,33.07L65.45,33.07z" />
                        <polygon points="71.07,45.32 65.38,43.44 62.54,43.04 65.2,44.1 71.07,45.32" />
                        <path d="M67.81,34.43c-0.22-0.17-0.53-0.13-0.7,0.09c-0.17,0.22-0.13,0.53,0.09,0.7c0.22,0.17,0.53,0.13,0.7-0.09 C68.07,34.91,68.03,34.6,67.81,34.43L67.81,34.43z" />
                        <polygon points="70.08,47.73 65.07,44.44 62.43,43.31 64.72,45.03 70.08,47.73" />
                        <path d="M69.75,36.37c-0.17-0.22-0.48-0.26-0.7-0.09s-0.26,0.48-0.09,0.7c0.17,0.22,0.48,0.26,0.7,0.09 C69.87,36.9,69.92,36.58,69.75,36.37L69.75,36.37z" />
                        <polygon points="68.49,49.79 64.5,45.32 62.25,43.55 64.02,45.8 68.49,49.79" />
                        <path d="M71.12,38.73c-0.11-0.25-0.4-0.38-0.65-0.27s-0.38,0.4-0.27,0.65c0.11,0.25,0.4,0.37,0.65,0.27 C71.1,39.28,71.22,38.99,71.12,38.73L71.12,38.73z" />
                        <polygon points="66.43,51.38 63.73,46.02 62.01,43.73 63.14,46.37 66.43,51.38" />
                        <path d="M71.82,41.37c-0.04-0.27-0.29-0.46-0.56-0.43c-0.27,0.04-0.46,0.29-0.43,0.56c0.04,0.27,0.29,0.46,0.56,0.43 C71.67,41.9,71.86,41.65,71.82,41.37L71.82,41.37z" />
                        <polygon points="64.02,52.37 62.8,46.51 61.73,43.84 62.14,46.68 64.02,52.37" />
                      </g>
                    </svg>
                  </>
                </div>
              </div>
            </div>
            <div className="input-wrapper">
              <input
                className="form-field w-input"
                autoFocus={true}
                maxLength={256}
                name="Phone-Number-2"
                data-name="Phone Number 2"
                placeholder="Phone"
                type="tel"
                id="Phone-Number-2"
                data-ms-member="phone"
                required=""
                value={phone} // Bind state to input value
                onChange={handleInputChange} // Listen for changes
              />
            </div>
          </div>
          {error && (
            <div className="text-red-600">Please enter valid phone number</div>
          )}

          <input
            type="submit"
            data-wait="Please wait..."
            className="button-4 w-button"
            defaultValue="Login"
            onClick={handleSubmit}
          />
          <p className="signup-grey-text">
            Signing up for a HighTable's account means you agree to the{" "}
            <Link to={"/privacy"} target="_blank" className="link-6">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link target="_blank" to="/terms" className="link-6">
              Terms of Service
            </Link>
            .<br />
          </p>
          {/* {SignupPage ? (
            <div onClick={() => setSignupPage(false)}>
              <p className="signup-back-link">
                Already have an account?{" "}
                <a
                  href="login.html"
                  aria-current="page"
                  className="link-6 w--current"
                >
                  Login up here
                </a>
                <br />
              </p>
            </div>
          ) : (
            <div
              onClick={(event) => {
                event.preventDefault();
                setSignupPage(true);
              }}
            >
              <p className="signup-back-link">
                Don't have an account?{" "}
                <a aria-current="page" className="link-6 pointer w--current">
                  Sign up here
                </a>
                <br />
              </p>
            </div>
          )} */}
        </>
      </form>
      <div className="w-form-done">
        <div>Thank you! Your submission has been received!</div>
      </div>
      <div className="w-form-fail">
        <div>Oops! Something went wrong while submitting the form.</div>
      </div>
    </div>
  );
};

export default PhoneInput;
